<template>
    <div id="booking-staff-setting">
        <div class="vx-breadcrumb mb-6">
            <ul class="flex flex-wrap items-center">
                <li class="inline-flex items-end">
                    <router-link to="/after-login">
                        <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
                    </router-link>
                    <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
                </li>
                <li class="inline-flex items-end">
                    <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Booking Staff Setting</span>
                </li>
            </ul>
        </div>
        <vx-card class="booking-staff-setting">
            <div v-if="staffsList && staffsList.length > 0">
                <div class="flex justify-between py-3">
                    <p>Staff</p>
                    <p>Active</p>
                </div>
                <div class="border-top-custom">
                    <div class="flex border-bottom-custom" v-for="(staff, index) in staffsList" :key="index">
                        <div class="mr-1" v-if="staff">
                            <vs-avatar
                                :src="staff.image_url"
                                class="border-2 border-solid border-white text-xl"
                                size="42px"
                                :text="StringHelper.changeFormatAvatar(staff.name)"
                                :color="staff.color_code"
                            ></vs-avatar>
                        </div>
                        <div class="w-full flex items-center justify-between">
                            <div class="flex w-full justify-between">
                                <div>
                                    <h5 class="font-semibold">{{staff.name}}</h5>
                                </div>

                                <div>
                                    <vs-switch v-model="isActive"></vs-switch>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="staffsData._meta.pageCount">
                    <custom-pagination class="custom-pagination" :totalPages="parseInt(staffsData._meta.pageCount)" :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
                </div>
            </div>
            <div v-else class="text-center">
                No data available
            </div>
        </vx-card>
    </div>
</template>

<script>
    import { StringHelper } from "../../models/string_helper";
    export default {
        data() {
            return {
                StringHelper,
                currentPage: 1,
                isActive: true,
                page_key: 0
            }
        },
        methods: {
            changePage(currentPage) {
                const obj = {
                    page: currentPage,
                    "per-page": 10,
                    sort: 'user_id'
                }
                // this.openLoadingInDiv();
                this.$store.dispatch("staffList/GET_STAFF_LIST", obj).then(()=>{
                    // this.closeLoading();
                })

                this.currentPage = currentPage;
                this.page_key++;
            },
        },
        computed: {
            staffsList() {
                return this.$store.getters["staffList/staffList"];
            },
            staffsData() {
                return this.$store.getters["staffList/staffData"];
            }
        },
        created() {
            const obj = {
                page: this.currentPage,
                "per-page": 10,
                sort: 'user_id'
            }
            this.$store.dispatch("staffList/GET_STAFF_LIST", obj).then(() => {

            }).catch(error=>console.log(JSON.parse(error)));
        }
    }
</script>

<style lang="scss">
    #booking-staff-setting {
        .booking-staff-setting {
            width: 100%;
            min-height: 500px;
            height: 100%;
        }
    }
</style>